import React,{ useState, useEffect} from 'react'
import { useSelector, useDispatch} from 'react-redux';
import * as actionsPolicy  from '../../../../app/actions/policy';
import InitialDataView from './initialDataView';

const InitialDataScreen = ({onForward, style}) => {

    const dispatch = useDispatch();

    const insVehicleInfo = useSelector(state => state.insVehicleInfo);
    const {registrationProps, location, initialData} = insVehicleInfo;
    const {locationCode, districtName} = location || {};
    const {plate, registered} = initialData || {};
    const insCompanies = useSelector(state => state.insCompanies);

    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [noRegData, setNoRegData] = useState(false);


    useEffect(() => {

        const loadInsCompanies = async () => {
            setLoading(true)
            await dispatch(actionsPolicy.getInsCompanies())
            setLoading(false)
        }

        loadInsCompanies();

    }, [dispatch]);

    useEffect(() => {

        if(submitted && registrationProps && registrationProps.messageCode) {
            setSubmitted(false);
            setLoading(false);
            setNoRegData(true);
        }

        if(submitted && plate && registered) {
            if(Object.keys(registrationProps).length && !registrationProps.messageCode 
                && (locationCode || districtName) && insCompanies.length) {
                setSubmitted(false);
                setLoading(false)
                onForward(2);
            }
        }
    }, [locationCode, insCompanies, submitted, plate, registered, districtName,
         registrationProps, onForward]);

    const submitHandler = async (data) => {
        const {registered, plate, talon} = data;

        setLoading(true);
        
        if(registered) {
            await dispatch(actionsPolicy.getLocation(plate));

            await dispatch(actionsPolicy.getRegProps(plate, talon));

            setTimeout(() => {
                setSubmitted(true);
            }, 0);

        } else {
            onForward(2);
        }
    }

    const onConfirm = () => {
        setNoRegData(false);
    }

    return (
        <div style={style}>
            <InitialDataView onSubmit={submitHandler} loading={loading} noRegData={noRegData} onConfirm={onConfirm}/>
        </div>
    )
}

export default InitialDataScreen;
